import React, { HTMLAttributes, useMemo } from 'react';

interface ITBodyProps extends HTMLAttributes<HTMLTableSectionElement> {
  paddingTop?: number;
  paddingBottom?: number;
  children?: React.ReactNode;
  height?: number;
}

const TBody: React.FC<ITBodyProps> = ({ paddingTop, paddingBottom, height, children, ...rest }) => {
  const paddingTopExist = useMemo(() => paddingTop !== undefined && paddingTop > 0, [paddingTop]);
  const paddingBottomExist = useMemo(
    () => paddingBottom !== undefined && paddingBottom > 0,
    [paddingBottom],
  );

  return (
    <tbody {...rest} style={{ height: height ? `${height}px` : undefined }}>
      {paddingTopExist && (
        <tr>
          <td style={{ height: `${paddingTop}px` }} />
        </tr>
      )}
      {children}
      {paddingBottomExist && (
        <tr>
          <td style={{ height: `${paddingBottom}px` }} />
        </tr>
      )}
    </tbody>
  );
};

export { TBody };
